export default {
    'name': '',
    'jobName': '',
    'groupName': '',
    'taskId': '',
    'processServiceId': '',
    'deployementId': '',
    'processInstanceId': '',
    'taskInstanceId': '',
    'jobType': 0,
    'jobCode': '',
    'cronJobRule': '',
    'executeStatus': 0,
    'isCrond': 0,
    'remark': '',
    'created': '',
    'createdBy': '',
    'tenantId': '',
    'startAt':'',
    'receiverIds':'',
    'receiverNames':''
};



// WEBPACK FOOTER //
// ./src/pages/application/Notice/NoticeEdit/defaultCronjob.js